/* eslint-disable func-names */
import { Emoji } from 'emoji-mart';
import moment from 'moment';
import { nanoid } from 'nanoid';
import { EmojiSize } from '../utils/constants';
import { getCke } from './cookieHelper';

export function generateRandomId() {
  const shortName = getCke('instituteName')
    .match(/\b(\w)/g)
    .join('');
  const random5Digit = Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
  return `${shortName}${random5Digit}`;
}

export function checkForMessage(type) {
  if (type === 'receive') {
    return true;
  }
  if (type === 'sent') {
    return true;
  }
  return false;
}

export const sortArrayInAscending = (array, key, sortBy = 'asc') => {
  if (sortBy === 'asc') {
    return array.sort((x, y) => x[key] - y[key]);
  }

  if (sortBy === 'desc') {
    return array.sort((x, y) => y[key] - x[key]);
  }

  return null;
};

export const FilterArrayByKey = (array, key) => {
  const filtered = [];
  for (let i = 0; i < array.length; i += 1) {
    let isHasNotEqual = true;
    for (let j = 0; j < filtered.length; j += 1) {
      if (filtered[j][key] === array[i][key]) {
        isHasNotEqual = false;
      }
    }
    if (isHasNotEqual) {
      filtered.push(array[i]);
    }
  }
  return filtered;
};

export const CheckForURL = (message) => {
  const isValid = /(?:(?:https?|ftp):\/\/)?[\w/\-?=%.]+\.[\w/\-?=%.]+/.test(message);
  return isValid;
};

export const GenerateLink = (text) => {
  const splitText = text.split(' ');
  const convertedText = [];
  splitText.forEach((split) => {
    // url regex for all type of url
    /* eslint-disable-next-line */
    const isValid = CheckForURL(split);
    if (isValid) {
      // if we have url like where http or https is missing then we have to add for ourselves for correctly open link in browser
      convertedText.push(
        <a
          className="chat-link"
          href={/^(http|https):\/\//.test(split) ? split : `http://${split}`}
          key={nanoid()}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            window.open(/^(http|https):\/\//.test(split) ? split : `http://${split}`);
          }}
        >
          {split}
        </a>
      );
    } else {
      convertedText.push(` ${split} `);
    }
  });
  return convertedText;
};

export const ColonsToUnicode = (text) => {
  const colonsRegex = new RegExp(String.raw('(^|)(:[a-zA-Z0-9-_+]+:(:skin-tone-[2-6]:)?)', 'g'));
  const newText = [];

  let match;
  const obj = [];
  while (match = colonsRegex.exec(text)) { // eslint-disable-line
    const colons = match[2];
    const offset = match.index + match[1].length;
    const { length } = colons;
    obj.push({
      colons,
      offset,
      length
    });
  }

  // In case no emoji
  if (obj.length === 0) {
    return GenerateLink(text);
  }

  for (let i = 0; i < obj.length; i += 1) {
    if (newText.length === 0) {
      newText.push(
        <p key={`col${i}`}>
          {GenerateLink(text.substring(0, obj[i].offset))}
          {'\u00a0'}
        </p>
      );
    }
    newText.push(
      <Emoji emoji={obj[i].colons} sheetSize={EmojiSize} size={24} apple key={i}>
        {obj[i].colons}
      </Emoji>
    );
    // text between two emojis
    const emojiPointerEnds = obj[i].offset + obj[i].length;
    if (!!obj[i + 1] && obj[i + 1].offset > emojiPointerEnds) {
      newText.push(
        <p key={`col1${i}`}>
          {GenerateLink(text.substring(emojiPointerEnds, obj[i + 1].offset))}
          {'\u00a0'}
        </p>
      );
    } else if (obj.length === i + 1 && emojiPointerEnds < text.length) {
      // remaining parts incase of last emoji
      newText.push(
        <p key={`col2${i}`}>
          {GenerateLink(text.substring(emojiPointerEnds, text.length))}
          {'\u00a0'}
        </p>
      );
    }
  }
  return newText;
};

export function checkIsImage(fileType) {
  return (
    fileType === 'image/jpg' ||
    fileType === 'image/gif' ||
    fileType === 'image/jpeg' ||
    fileType === 'image/png'
  );
}

export function GetDurationBetweenTwoDate(from, to) {
  const startTime = moment(from);
  const endTime = moment(to);

  const day = endTime.diff(startTime, 'days');
  const hours = endTime.diff(startTime, 'hours');
  const second = endTime.diff(startTime, 'seconds');
  const minutes = moment
    .utc(moment(endTime, 'HH:mm:ss').diff(moment(startTime, 'HH:mm:ss')))
    .format('mm');

  if (day !== 0) {
    return `${day} days`;
  }
  if (minutes === 0) {
    return `${second} sec`;
  }
  if (hours === 0) {
    return `${minutes} minutes`;
  }

  return `${minutes > 0 ? `${hours}.${minutes} hour` : `${hours} h`}`;
}

export function ConvertToBase64(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result.split('base64,')[1]);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
}

export function CalculateUserProfilePercentage(user) {
  /**
   * Here 6 is number of field which is compulsory:
   * Name
   * Dob
   * Email
   * City
   * Gender
   * Profile image
   */
  const percentToBeAdded = 100 / 6;
  let completedPercentage = 0;
  if (user.fullName) {
    completedPercentage += percentToBeAdded;
  }
  if (user?.dob) {
    completedPercentage += percentToBeAdded;
  }
  // If user logged with gmail then mobile is checked
  // if (user.isGmailLink && user?.mobileNumber) {
  //   completedPercentage += percentToBeAdded;
  // } else
  if (user?.email) {
    completedPercentage += percentToBeAdded;
  }
  if (user?.city) {
    completedPercentage += percentToBeAdded;
  }
  if (user?.profileImage) {
    completedPercentage += percentToBeAdded;
  }
  if (user.gender) {
    completedPercentage += percentToBeAdded;
  }
  return Math.round(completedPercentage);
}

export function CalculateOrgProfilePercentage(org) {
  /**
   * Here 9 / 8 is differ in org type:
   * Name
   * Board // in case of type school
   * Website
   * Email
   * Address
   * City
   * State
   * Zipcode
   * Profile image
   */
  const percentToBeAdded = org.orgType === 'school' ? 100 / 9 : 100 / 8;
  let completedPercentage = 0;
  if (org.name) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.website) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.email) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.address) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.city) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.state) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.zipCode) {
    completedPercentage += percentToBeAdded;
  }
  if (org?.instituteProfileImage) {
    completedPercentage += percentToBeAdded;
  }
  if (org.orgType === 'school' && org?.eduBoard) {
    completedPercentage += percentToBeAdded;
  }
  return Math.round(completedPercentage);
}

/**
 * Get offer categories array.
 * @param {array} offersData offer data which comes from api
 * @returns {array} new filter array which made from offers category
 */
export function GetOfferCategories(offersData) {
  const subfilterArray = [];
  subfilterArray.push({
    id: nanoid(),
    name: 'All',
    filterText: 'all'
  });
  for (let i = 0; i < offersData.length; i += 1) {
    const element = offersData[i];
    if (element.Coupon_Category) {
      element.Coupon_Category.split(',').map((cat) => {
        const findIndex = subfilterArray.findIndex(
          (fil) => fil.name.toLowerCase() === cat.toLowerCase()
        );
        if (findIndex === -1) {
          subfilterArray.push({
            id: nanoid(),
            name: cat,
            filterText: cat.toLowerCase()
          });
        }
        return null;
      });
    }
  }
  return subfilterArray;
}

/**
 * This function is used for get the status about is class online or not.
 *
 * @param {array} classTiming Timing array for all the day.
 * @returns {boolean} return flag.
 */
export function CheckClassIsOnline(classTiming) {
  // Flag to return class status
  let selectedTime = null;
  // Loop through classes
  classTiming.forEach((day) => {
    // If current day and we have for the same
    if (day.day === moment().format('dddd') && day.selected) {
      // Loop through slots
      for (let i = 0; i < day.slots.length; i += 1) {
        const slot = day.slots[i];

        // Get today day with time 12 am in morning
        // For ex: 16/07/2022 12:00 am
        const todayDateWhenDayStart = moment().hour(0).minute(0).second(0).toISOString();

        const classBeginningTime = moment(todayDateWhenDayStart)
          .add(moment(slot.from).hour(), 'hour')
          .add(moment(slot.from).minute(), 'minute');
        const classEndTime = moment(todayDateWhenDayStart)
          .add(moment(slot.to).hour(), 'hour')
          .add(moment(slot.to).minute(), 'minute');
        const currentTime = moment();

        // Check if current timing is in between slot timing or not and class is not online
        if (
          currentTime.isAfter(classBeginningTime) &&
          currentTime.isBefore(classEndTime) &&
          selectedTime === null
        ) {
          // Make it true.
          selectedTime = slot;
        }
      }
    }
  });
  return selectedTime;
}

/**
 * This Debounce function is used for to wait certain amount while doing some operation
 * @param {function} func // Provide function to use debounce on it
 * @param {timestamp} wait // How many minute you've to wait to do action
 * @param {boolean} immediate // Want to bypass the timeout.
 * @returns
 */
export const Debounce = function (func, wait, immediate) {
  let timeout;
  return function () {
    const context = this;
    // eslint-disable-next-line prefer-rest-params
    const args = arguments;
    const later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    const callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};
